
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum UserType {
    View = "View",Normal = "Normal",Admin = "Admin",
}

export enum UserTypeDisplay {
    View = "View",Normal = "Normal",Admin = "Admin",
}

export const UserTypePairs = Object.keys(UserType)
  .map(key=> ({id: key, name: UserType[key]}));

export function toString(value?: EnumSelect): string {
  return value ? UserType[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case UserTypeDisplay.View:
            return t`View`;
            
        case UserTypeDisplay.Normal:
            return t`Normal`;
            
        case UserTypeDisplay.Admin:
            return t`Admin`;
            
        default:
            return undefined;
    }
}
